  import { Injectable } from '@angular/core';
  import { Http, Headers, RequestOptions } from '@angular/http';
  import 'rxjs/add/operator/map';
  import { Storage } from '@ionic/storage'

  import { URL_SERVICIOS_LOCALES,RUTA_MODO_DESCONECTADO, NUBE_AWS, URL_SERVICIOS_AWS } from '../../config/url.servicio'
  import { ElectronService } from 'ngx-electron';

  @Injectable()
  export class SeguimientoIngresosStockProvider {
  token:string
    constructor(public http: Http,
                public storage:Storage,
                private _electronService: ElectronService) {
      this.storage.get('token').then((val) => {
        this.token = val
    });
      this.buscar()
    }

    buscar() {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        return this.http.get(`${url_servicio}/procedure?name=SeguimientoIngresosStock`);
      } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/query?name=SeguimientoIngresosStock`)
          .map((data) => data.json())
     }
    }

    guardar(SeguimientoIngresosStock: any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: SeguimientoIngresosStock.name,
          parameters : {
            name : "dataDynamicCrud",
            nombreTabla: "seguimientoIngresosStock",
            ...SeguimientoIngresosStock
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => {
          data.json()}
        , error => {
          console.log(error)});
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.post(`${url}/query`, SeguimientoIngresosStock, options)
          .map((data) => {data.json()},
        (error)=>{
          console.log(error)
        })
      }
    }

    guardarModoDesconectado(SeguimientoIngresosStock: any) {
      const datos = {
        "SeguimientoIngresosStock": JSON.stringify(SeguimientoIngresosStock),
        "RUTA_MODO_DESCONECTADO":RUTA_MODO_DESCONECTADO
    }

   return  this._electronService.ipcRenderer.sendSync('guardar-seguimiento-ingresos-stock-mododesconectado',datos, (event, data) => {
    })
    }

    actualizarExistenciaProducto(producto: any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: producto.name,
          parameters : {
            name : "dataDynamicCrud",
            nombreTabla: "productos",
            ...producto
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => {data.json()},
        (error)=>{
          console.log(error)
        })
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })

        return this.http.post(`${url}/query`, producto, options)
          .map((data) => {data.json()},
        (error)=>{
          console.log(error)
        })
      }
    }

    buscarProductoPorId (id){
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: "buscarProductosPorId",
          parameters : {id:id}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.token
        })

        let options = new RequestOptions({
            headers: headers
        })

        const datos = {
            "id": id
            }

        return this.http
            .post(`${url}/proceso/buscarProductosPorId`, datos, options)
   }
  }


  buscarSeguimientoIngresosStockDiarios (fecha:any,companiasId:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: "buscarSeguimientoIngresosStockDiarios",
        parameters : {fecha : fecha,
                      companiasId:companiasId
                    }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })

      const datos = {
          "fecha": fecha,
          "companiasId":companiasId
          }

      return this.http
          .post(`${url}/proceso/buscarSeguimientoIngresosStockDiarios`, datos, options)
 }
}

    actualizar(SeguimientoIngresosStock: any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: SeguimientoIngresosStock.name,
          parameters : {
            name : "dataDynamicCrud",
            nombreTabla: "SeguimientoIngresosStock",
            ...SeguimientoIngresosStock
          }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, request, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      //?name=dataDynamicCrud&SeguimientoIngresosStockId=${SeguimientoIngresosStock.SeguimientoIngresosStockId}&codigoSeguimientoIngresosStock=${SeguimientoIngresosStock.codigoSeguimientoIngresosStock}&nombreSeguimientoIngresosStock=${SeguimientoIngresosStock.nombreSeguimientoIngresosStock}&nombreTabla=SeguimientoIngresosStock
      return this.http.put(`${url}/query`, SeguimientoIngresosStock, options)
     }
    }
      eliminar(SeguimientoIngresosStock: any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let request = {
            name: SeguimientoIngresosStock.name,
            parameters : {
              name : "dataDynamicCrud",
              nombreTabla: "SeguimientoIngresosStock",
              ...SeguimientoIngresosStock
            }
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, request, options);
        } else {
          let url = URL_SERVICIOS_LOCALES
          let headers = new Headers({
            'Content-Type': 'application/json'
          })
          let options = new RequestOptions({
            headers: headers
          })
          //?name=dataDynamicCrud&SeguimientoIngresosStockId=${SeguimientoIngresosStock.SeguimientoIngresosStockId}&nombreTabla=SeguimientoIngresosStock
          return this.http.delete(`${url}/query?name=dataDynamicCrud&queHago=E&SeguimientoIngresosStockId=${SeguimientoIngresosStock.SeguimientoIngresosStockId}&nombreTabla=SeguimientoIngresosStock`, options)
     }
    }

    buscarTodosLosinformes(data:any,nombre:any,ruta:any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let request = {
          name: "informes",
          parameters : {data: JSON.stringify(data),
                        nombre:nombre,
                        ruta:ruta
                      }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        this.http.post(`${url_servicio}/procedure`, request, options);
        this.storage.set('imprimirArchivo',nombre)
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',

        })
        let options = new RequestOptions({
          headers: headers
        })
        const datos = {
            "data": JSON.stringify(data),
            "nombre":nombre,
            "ruta":ruta
            }

        this.http.post(`${url}/informes`,datos,options)
        .subscribe((data)=>{

        },(error)=>{

        })

        this.storage.set('imprimirArchivo',nombre)
      }
   }

   actualizarPrecioProducto(data: any,nombreTabla:any = 'productos') {
      let url_servicio = URL_SERVICIOS_AWS;
      let request = {
        name: data.name,
        parameters : {
          name : "dataDynamicCrud",
          nombreTabla: nombreTabla,
          ...data
        }
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, request, options).map((data) => {
        data.json()}
      , error => {
        console.log(error)});

  }

  }



// WEBPACK FOOTER //
// ./src/providers/seguimiento-ingresos-stock/seguimiento-ingresos-stock.ts